
import React from 'react';
import { ExternalLink, Globe, Bookmark, Award, TrendingUp, MessageSquareShare } from 'lucide-react';
import { Button } from '@/components/ui/button';

const ManamuMediaSection: React.FC = () => {
  return (
    <section className="py-20 relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute inset-0 bg-gradient-to-br from-amber-50 via-amber-100/70 to-amber-50"></div>
      <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-gradient-to-b from-amber-200/30 to-transparent blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-1/3 h-1/3 bg-gradient-to-t from-amber-300/20 to-transparent blur-3xl"></div>
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-5xl mx-auto">
          <div className="mb-12 text-center">
            <div className="inline-flex items-center justify-center bg-amber-100 px-4 py-2 rounded-full mb-6">
              <Globe className="h-5 w-5 text-amber-600 mr-2" />
              <span className="text-amber-800 font-medium">Our Mission</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-6 bg-gradient-to-r from-amber-700 to-amber-500 bg-clip-text text-transparent">
              What Is Manamu Media
            </h2>
            
            <div className="w-16 h-1 bg-gradient-to-r from-amber-400 to-amber-600 mx-auto rounded-full mb-8"></div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            <div className="bg-white p-6 rounded-xl shadow-md border border-amber-100 transform transition-all hover:shadow-lg hover:-translate-y-1">
              <div className="bg-amber-100 w-12 h-12 rounded-full flex items-center justify-center mb-4">
                <Award className="h-6 w-6 text-amber-600" />
              </div>
              <h3 className="text-xl font-semibold mb-2">Creative Impact</h3>
              <p className="text-gray-600">
              We don’t just create content — we craft stories that inspire action, influence minds, and build emotional connection with your audience.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-md border border-amber-100 transform transition-all hover:shadow-lg hover:-translate-y-1">
              <div className="bg-amber-100 w-12 h-12 rounded-full flex items-center justify-center mb-4">
                <Bookmark className="h-6 w-6 text-amber-600" />
              </div>
              <h3 className="text-xl font-semibold mb-2">Strategic Clarity</h3>
              <p className="text-gray-600">
              From visual branding to digital growth, we align every creative decision with your business goals, ensuring your message lands with impact.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-md border border-amber-100 transform transition-all hover:shadow-lg hover:-translate-y-1">
              <div className="bg-amber-100 w-12 h-12 rounded-full flex items-center justify-center mb-4">
                <TrendingUp className="h-6 w-6 text-amber-600" />
              </div>
              <h3 className="text-xl font-semibold mb-2">Founder-First Approach</h3>
              <p className="text-gray-600">
              We work closely with founders, bringing out the voice, vision, and vibe of their brand; because people follow people, not logos.
              </p>
            </div>
          </div>
          
          <div className="bg-gradient-to-r from-amber-500 to-amber-600 rounded-2xl p-8 shadow-xl text-white relative overflow-hidden">
            <div className="absolute top-0 right-0 opacity-20">
              <svg width="180" height="180" viewBox="0 0 180 180" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="90" cy="90" r="90" fill="white" />
                <circle cx="90" cy="90" r="70" fill="transparent" stroke="white" strokeWidth="5" />
                <circle cx="90" cy="90" r="40" fill="transparent" stroke="white" strokeWidth="5" />
              </svg>
            </div>
            
            <div className="relative z-10 text-center">
              <h3 className="text-2xl md:text-3xl font-bold mb-3 flex items-center justify-center">
                <MessageSquareShare className="mr-2 h-6 w-6" />
                Share Your Story with Us
              </h3>
              <p className="text-lg md:text-xl font-medium mb-6 text-white/90">
                Have a success story or insight to share? We want to hear from you and feature your story on Manamu Media.
              </p>
              
              <Button 
                size="lg" 
                variant="outline"
                className="bg-white text-amber-600 hover:bg-amber-50 border-white group shadow-lg hover:shadow-xl transition-all"
                onClick={() => window.open("https://wa.me/+919347537540?text=Hi%2C%20I%20want%20to%20list%20my%20story%20on%20Manamu%20Media", "_blank")}
              >
                Share Your Story 
                <ExternalLink className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ManamuMediaSection;
